/** Request com os dados para salvar uma Análise de Mercado RAP Mensal */
export class ClienteAnaliseMercadoRAPSaveMesRequest {
    mes: number;
    valorPotencial: number;
    valorPretendido: number;

    constructor(props: Partial<ClienteAnaliseMercadoRAPSaveMesRequest>) {
        Object.assign(this, props);
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objeto criado
     */
    static fromJSON(json: string): ClienteAnaliseMercadoRAPSaveMesRequest {
        return new ClienteAnaliseMercadoRAPSaveMesRequest(JSON.parse(json));
    }
}
